module.exports = __webpack_public_path__ + "static/media/country_hm.73d77924.webp";